import { render } from "./service_delivery_performance.html?vue&type=template&id=054d987d&external"
import script from "./service_delivery_performance.js?vue&type=script&lang=js&external"
export * from "./service_delivery_performance.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__